export default "__VITE_ASSET__BM6Gxy_H__"